<template>
  <div class="plugin-anchor_point" :id="config.text" v-if="config && config.text"></div>
</template>

<script>
export default {
  name: "AnchorPoint",
  props: {
    config: { type: Object, required: true }
  }
}
</script>

<style>

</style>